import { ActionBar } from '@revolut-internal/ui-kit'
import styled from 'styled-components'

export const ChatMessageActionItem = styled(ActionBar.Item)`
  // reduce hover space to avoid overlap
  & > span > div:before {
    inset: unset;
  }
`
